<template>
    <div>
        <div class="text-subtitle1">Prepaid Code</div>
        <p>You have selected the option to activate a pre-purchased license. Enter the Prepaid Code that was supplied to you.</p>
        <div class="row">
            <q-input outlined dense
                     label="Prepaid Code" stack-label
                     autocomplete="off"
                     v-model.trim="code"
                     ref="codeRef"
                     :loading="isDiscountCodeValidPending"
                     :error="!isValidCode"
                     @input="checkCodeValid()"
                     class="col-xs-12 col-md-6"
                     :rules="[ val => $v.code.required || 'Prepaid code is required' ]"
                     hide-bottom-space>
                <template v-slot:append>
                    <q-icon v-if="showCheck" name="mdi-check-bold" color="positive" />
                </template>
                <div v-if="discountCodeObj && isValidCode" class="row text-positive text-caption text-right">
                    Discount Amount {{ calculateDiscountAmount | currency }}
                </div>
            </q-input>
        </div>
        <div v-if="!isValidCode" v-html="isValidCodeErrorMessage" style="font-size: 0.8em; color: var(--q-color-negative); padding: 5px 12px 0;"></div>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { required } from 'vuelidate/lib/validators'

    export default {
        name: 'validate-code',
        props: {
            licenses: Array,
            product: Object,
            formDiscountCode: String,
            required: {
                default: true,
                type: Boolean
            },
        },
        data() {
            return {
                showCheck: false,
                discountCodeObj: null,
                code: '',
                isValidCode: true,
                isValidCodeErrorMessage: '',
            }
        },
        validations: {
            code: { required },
        },
        methods: {
            clearError() {
                this.showCheck = false
                this.discountCodeObj = null
                this.isValidCode = true
                this.isValidCodeErrorMessage = ''
            },
            checkCodeValid() {

                this.clearError()

                this.$store.dispatch('getCodeType', this.code).then(() => {

                    if (this.getCodeTypeData !== 'undefined') {

                        if (this.getCodeTypeData == 'licenseKey') { // code is license key.

                            this.isValidCodeErrorMessage = '\'' + this.code + '\' is a License Key. If issue persists, please <a href="/support/ticket">contact Avenir Software</a>.'
                            this.isValidCode = false
                            this.$emit('updateDiscountCode', '')
                            this.$emit('updateProduct', null)

                        } else if (this.getCodeTypeData == 'prepaidCode') { //code is prepaid code.
                            if (this.code) {
                                this.$store.dispatch('validateDiscountCode', this.code).then(() => {
                                    if (typeof this.isDiscountCodeValidData !== 'undefined') {
                                        this.discountCodeObj = this.isDiscountCodeValidData
                                        if (!this.discountCodeObj) {
                                            this.isValidCodeErrorMessage = 'The prepaid code \'' + this.code + '\' is invalid.'
                                            this.isValidCode = false
                                            this.$emit('updateDiscountCode', '')
                                            this.$emit('updateProduct', null)
                                        }
                                        else if (!this.discountCodeObj.used) {
                                            let product = this.licenses?.find(l => l.id == this.discountCodeObj.validProducts)
                                            if (product) {
                                                if (product.isSubscription) {
                                                    this.isValidCodeErrorMessage = 'The prepaid code \'' + this.code + '\' is for a Subscription Renewal. Please go back and select the Subscription Renewal option.'
                                                    this.isValidCode = false
                                                    this.$emit('updateDiscountCode', '')
                                                    this.$emit('updateProduct', null)
                                                }
                                                else {
                                                    this.isValidCode = true
                                                    this.showCheck = true
                                                    this.$emit('updateDiscountCode', this.code)
                                                    this.$emit('updateProduct', product)
                                                }
                                            }
                                            else {
                                                this.isValidCodeErrorMessage = 'The prepaid code \'' + this.code + '\' is not valid for the selected product.'
                                                this.isValidCode = false
                                                this.$emit('updateDiscountCode', '')
                                                this.$emit('updateProduct', null)
                                            }
                                        }
                                        else if (this.discountCodeObj.used) {
                                            this.isValidCodeErrorMessage = 'The prepaid code \'' + this.code + '\' has already been used.'
                                            this.isValidCode = false
                                            this.$emit('updateDiscountCode', '')
                                            this.$emit('updateProduct', null)
                                        }
                                        else {
                                            this.isValidCodeErrorMessage = 'The prepaid code \'' + this.code + '\' is not valid for the selected product.'
                                            this.isValidCode = false
                                            this.$emit('updateDiscountCode', '')
                                            this.$emit('updateProduct', null)
                                        }
                                    }
                                })
                            }
                        } else if (this.getCodeTypeData == 'discountCode') { //code is discount code.
                            this.isValidCodeErrorMessage = '\'' + this.code + '\' is a Discount code. If issue persists, please <a href="/support/ticket">contact Avenir Software</a>.'
                            this.isValidCode = false
                            this.$emit('updateDiscountCode', '')
                            this.$emit('updateProduct', null)
                        }
                    } else {
                        this.isValidCodeErrorMessage = 'Unknown code type.'
                        this.isValidCode = false
                        this.$emit('updateDiscountCode', '')
                        this.$emit('updateProduct', null)
                    }
                })


            },

        },
        computed: {
            ...mapState([
                'isDiscountCodeValidPending',
                'isDiscountCodeValidData',
                'getCodeTypePending',
                'getCodeTypeData'
            ]),
            cart() { return this.$store.getters.cart },
            calculateDiscountAmount() {
                if (this.product && this.discountCodeObj && this.isValidCode) {
                    if (this.discountCodeObj.valuePercent) {
                        if (this.cart.currency == 1) return this.product.listPriceCDN * this.discountCodeObj.valuePercent / 100
                        else return this.product.listPriceUS * this.discountCodeObj.valuePercent / 100
                    }
                    if (this.cart.currency == 1) return this.discountCodeObj.valueCDN
                    else return this.discountCodeObj.valueUS
                }
                return 0
            },
        },
        created() {
            if (this.formDiscountCode) {

                if (this.formDiscountCode) {
                    this.code = this.formDiscountCode
                }

                this.checkCodeValid()
            }
        }
    }
</script>
